import React from 'react';
import { Header } from 'components';
import './DesktopPageLayout.scss';
import { useLocation } from 'react-router-dom';
import { HomePageLayout } from '../homePageLayout';

interface DesktopPageLayoutProps {
  children: React.ReactNode;
}

function DesktopPageLayout({ children }: DesktopPageLayoutProps) {
  const location = useLocation();
  if (location.pathname === '/') {
    return <HomePageLayout>{children}</HomePageLayout>;
  }
  return (
    <div className="desktop-layout">
      <div className="desktop-layout-header">
        <Header />
      </div>
      <div className="desktop-layout-content">{children}</div>
    </div>
  );
}

export default DesktopPageLayout;
